import React from 'react';
import { Form } from 'react-final-form';
import { TextField } from 'mui-rff';
import { Button, Box, Typography, Container, useTheme } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useSnackbar } from '../../contexts/SnackbarContext';

interface ResumeFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  resume: File | null;
}

export default function Careers() {
  const theme = useTheme();
  const { snackbar, snackbarDispatch } = useSnackbar();
  const handleSubmit = async (values: ResumeFormValues) => {
    console.log('Form submitted:', values);
    // Handle form submission logic here
    snackbarDispatch({type: 'setSnackbar', payload: {message: "Resume Submitted", error: false}})
    
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const validTypes = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf'];
      if (!validTypes.includes(file.type)) {
        alert('Please upload a .docx or PDF file');
        return;
      }
    }
  };

  const validate = (values: ResumeFormValues) => {
    const errors: Partial<Record<keyof ResumeFormValues, string>> = {};
    if (!values.firstName?.trim()) {
      errors.firstName = 'First Name is required';
    }
    if (!values.lastName?.trim()) {
      errors.lastName = 'Last Name is required';
    }
    if (!values.email?.trim()) {
      errors.email = 'Email is required';
    }
    if (!values.phone?.trim()) {
      errors.phone = 'Phone Number is required';
    }
    return errors;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.dark} 100%)`,
        py: 6,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            background: 'white',
            borderRadius: '16px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            p: 5,
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: '#1a1a1a',
              mb: 1,
              textAlign: 'center',
            }}
          >
            Join Us
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#666',
              textAlign: 'center',
              mb: 4,
            }}
          >
            Be a part of our growing Team!
          </Typography>
          <Form
            onSubmit={handleSubmit}
            validate={validate}
            initialValues={{
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              resume: null,
            }}
            render={({ handleSubmit, values, errors, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                  <TextField
                    name="firstName"
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    required
                  />
                  <TextField
                    name="lastName"
                    label="Last Name"
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Box>
                <TextField
                  name="email"
                  label="Email Address"
                  type="email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  required
                />
                <TextField
                  name="phone"
                  label="Phone Number"
                  type="tel"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  required
                />
                <Box sx={{ my: 3 }}>
                  <input
                    accept=".docx,.pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="resume-upload"
                  />
                  <label htmlFor="resume-upload">
                    <Button
                      variant="outlined"
                      component="span"
                      startIcon={<CloudUploadIcon />}
                      fullWidth
                      sx={{
                        py: 2,
                        borderColor: theme.palette.primary.main,
                        color: theme.palette.primary.main,
                        borderWidth: 2,
                        '&:hover': {
                          borderWidth: 2,
                          backgroundColor: theme.palette.primary.light,
                        },
                      }}
                    >
                      Upload Resume (.docx or PDF)
                    </Button>
                  </label>
                </Box>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 3,
                    py: 1.5,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                    fontSize: '1rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    '&:hover': {
                      boxShadow: `0 10px 30px ${theme.palette.primary.main}66`,
                    },
                  }}
                >
                  Submit Resume
                </Button>
              </form>
            )}
          />
        </Box>
      </Container>
    </Box>
  );
};
